import {
    memo, PropsWithChildren, useCallback, useMemo, useRef, useState,
} from 'react';
import { Toast } from 'src/modules/common/components/Toast/Toast';
import { ToastContext, ToastContextProps, ToastOptions } from 'src/modules/common/components/Toast/ToastContext';

const DEFAULT_DURATION = 4000;

type ToastItem = ToastOptions & { id: number };

export const ToastProvider = memo(({ children }: PropsWithChildren) => {
    const [toasts, setToasts] = useState<ToastItem[]>([]);
    const idRef = useRef(0);

    const removeToast = useCallback((id: number) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);

    const showToast = useCallback((options: ToastOptions) => {
        idRef.current += 1;

        setToasts((prev) => [...prev, { ...options, id: idRef.current }]);
    }, []);

    const value = useMemo<ToastContextProps>(() => ({ showToast }), [showToast]);

    return (
        <ToastContext.Provider value={value}>
            {children}

            <div className="vss-toast-container">
                {toasts.map(({
                    id, type, isLowContrast, title, message, duration,
                }) => (
                    <Toast
                        key={id}
                        type={type}
                        isLowContrast={isLowContrast}
                        title={title}
                        message={message}
                        duration={duration ?? DEFAULT_DURATION}
                        onClose={() => removeToast(id)}
                    />
                ))}
            </div>
        </ToastContext.Provider>
    );
});
